function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".gen_svg__cls-1{fill:#fff}.gen_svg__cls-2{fill:none;stroke:#fff;stroke-dasharray:1 1}"));
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "gen_svg__Ellipse_725",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "gen_svg__cls-1",
  transform: "translate(5 5)"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "gen_svg__Ellipse_726",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "gen_svg__cls-1",
  transform: "translate(0 10)"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "gen_svg__Ellipse_727",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "gen_svg__cls-1",
  transform: "translate(10 10)"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "gen_svg__Ellipse_728",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "gen_svg__cls-1",
  transform: "translate(15 5)"
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "gen_svg__Ellipse_729",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "gen_svg__cls-1",
  transform: "translate(10)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "gen_svg__Line_534",
  d: "M0 5l5-5",
  className: "gen_svg__cls-2",
  transform: "translate(6.5 1.5)"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "gen_svg__Line_535",
  d: "M0 0l4 4",
  className: "gen_svg__cls-2",
  transform: "translate(6.5 6.5)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "gen_svg__Line_536",
  d: "M4 0L0 4",
  className: "gen_svg__cls-2",
  transform: "translate(2.5 6.5)"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  id: "gen_svg__Line_537",
  d: "M5 5L0 0",
  className: "gen_svg__cls-2",
  transform: "translate(11.5 1.5)"
});
function SvgGen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "gen_svg__Component_120_2",
    width: 18,
    height: 13,
    viewBox: "0 0 18 13"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_120_2' width='18' height='13' viewBox='0 0 18 13'%3e %3cdefs%3e %3cstyle%3e .cls-1%7bfill:%23fff%7d.cls-2%7bfill:none;stroke:%23fff;stroke-dasharray:1 1%7d %3c/style%3e %3c/defs%3e %3ccircle id='Ellipse_725' cx='1.5' cy='1.5' r='1.5' class='cls-1' transform='translate(5 5)'/%3e %3ccircle id='Ellipse_726' cx='1.5' cy='1.5' r='1.5' class='cls-1' transform='translate(0 10)'/%3e %3ccircle id='Ellipse_727' cx='1.5' cy='1.5' r='1.5' class='cls-1' transform='translate(10 10)'/%3e %3ccircle id='Ellipse_728' cx='1.5' cy='1.5' r='1.5' class='cls-1' transform='translate(15 5)'/%3e %3ccircle id='Ellipse_729' cx='1.5' cy='1.5' r='1.5' class='cls-1' transform='translate(10)'/%3e %3cpath id='Line_534' d='M0 5L5 0' class='cls-2' transform='translate(6.5 1.5)'/%3e %3cpath id='Line_535' d='M0 0L4 4' class='cls-2' transform='translate(6.5 6.5)'/%3e %3cpath id='Line_536' d='M4 0L0 4' class='cls-2' transform='translate(2.5 6.5)'/%3e %3cpath id='Line_537' d='M5 5L0 0' class='cls-2' transform='translate(11.5 1.5)'/%3e %3c/svg%3e";
export { SvgGen as ReactComponent };